import request from "@/utils/request";
export function getProjectList(data) {
  return request({
    url: "/djmx/dataAcquisition/getProjectList",
    method: "post",
    data,
  });
}
export function importZipData(data) {
  return request({
    url: "/djmx/dataAcquisition/importZipData",
    method: "post",
    data,
  });
}

// 根据系统设置/获取聊天消息
export function questionCollection(data) {
  return request({
    url: "/ai/chat/message/questionCollection",
    method: "post",
    data,
  });
}
export function questionCollectionDetail(data) {
  return request({
    url: "/ai/chat/message/questionCollectionDetail",
    method: "post",
    data,
  });
}
export function getAiRewriteQuery(data) {
  return request({
    url: "/ai/chat/conversation/getAiRewriteQuery",
    method: "post",
    data,
  });
}
